import {asyncLoad} from '.';

export const loadTemplate = name => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Template',
    url: `/templates/${encodeURI(name)}`,
  });



// WEBPACK FOOTER //
// ./src/actions/templateActions.js